<ng-container *transloco="let translate">
    <div class="flex justify-between items-center relative -top-3">
        <h4 class="!mb-[7px] font-bold" mat-dialog-title [textContent]="translate('Initiate Cancel')"></h4>
        <span class="material-icons mb-1 cursorPointer" (click)="closeModal()">close</span>
    </div>
    <mat-dialog-content class="mat-typography">
        <span class="block" [textContent]="translate('Are you sure you want to cancel the process? Please note that the process cannot be canceled if it has already been completed or previously canceled.')"></span>
        <br />
        <span class="block" [textContent]="translate('Enter last 8 digits of below Id to confirm.')"></span>
        <br />
        <strong class="p-[10px] my-[10px] tracking-[3px]" *ngIf="isSingleRecord" [textContent]="assetDataId"></strong>
        <br />
        <div class="!mt-[15px]" *ngIf="isSingleRecord">
            <div class="col-12">
                <material-input appDisableClipboard [placeholder]="translate('Enter last 8 digits')" [model]="processId" (modelChange)="processId = $event" (keyUpEventHandler)="checkProcessId(processId)" [errors]="errors.processIdError" [name]="'processId'" [required]="true" [title]="processId"></material-input>
            </div>
        </div>
        <div class="col-12">
            <material-input [placeholder]="translate('Leave a comment')" [model]="cancelProcessComment" (modelChange)="cancelProcessComment = $event" (keyUpEventHandler)="checkDescriptionComment(cancelProcessComment)" [name]="'comment'" [required]="true" [title]="cancelProcessComment"></material-input>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <material-button class="mx-[10px]" [text]="translate('Close')" color="default" (click)="closeModal()"></material-button>
        <material-button class="mx-[10px]" [text]="translate('Submit')" [disabled]="!isValidDescription || !isValidProcessId" color="primary" (buttonClicked)="cancelInstance()"></material-button>
    </mat-dialog-actions>
</ng-container>
